<template>
  <div>
    <div class="content">
      <div class="container">
        <div class="details">
          <div>
            <h1 class="details_title">{{ detailsTitle }}</h1>
          </div>
          <div v-if="type === 2 || type === 3" class="details_img">
            <img :src="detailsSrc" alt="" />
          </div>
          <div class="details_content">
            <div v-html="content"></div>
          </div>
        </div>
        <div class="post_pages">
          <p>
            <span
              class="prev"
              :class="{ special: change.noPrev }"
              @click="changeHander('prev')"
              >{{ prevText }}</span
            >
            <span
              class="next"
              :class="{ special: change.noNext }"
              @click="changeHander('next')"
              >{{ nextText }}</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import HeaderB from "@/components/public/headerB";
import Code from "@/components/public/code";
import Footer from "@/components/public/footer";
export default {
  data() {
    return {
      toHeaderB: {
        title: "总体规划",
        parent: "走进湿地",
        parentLink: "/stepInWetland/stepInWetland",
        child: "",
        childLink: "",
        longTop: "",
        longBottom: "Introduction",
        shortValue: "",
        isLong: true,
        titleShow: false,
        searchShow: false,
        haveVoice: false,
        voiceImage: "",
        voiceTitle: "",
        voiceSrc: "",
        logoSrc: {
          backgroundImage: ""
        }
      },
      type: null,
      search: null,
      TouriseData: null,
      listData: null,
      prevText: "",
      nextText: "",
      detailsSrc: "",
      detailsTitle: "",
      content: "",
      imgList: [
        "jpeg2000",
        "jpg",
        "jpeg",
        "tiff",
        "psd",
        "png",
        "swf",
        "svg",
        "pcx",
        "dxf",
        "wmf",
        "emf",
        "lic",
        "fli",
        "flc",
        "eps",
        "tga",
        "bmp",
        "gif"
      ],
      voiceList: [
        "wav",
        "flac",
        "ape",
        "alac",
        "wavpack",
        "mp3",
        "mp3pro",
        "wma",
        "mpeg",
        "ra",
        "rm",
        "rmx",
        "midi",
        "aac",
        "ogg",
        "oggvorbis",
        "opus",
        "cda"
      ],
      change: {
        nowIndex: null,
        nowTitle: "",
        nowId: "",
        noPrev: false,
        noNext: false
      }
    };
  },
  components: {
    HeaderB,
    Code,
    Footer
  },
  methods: {
    // 播放事件
    renderData(data) {
      let pause,
        isStart,
        player = document.getElementById("player"),
        obj = this.toHeaderB;
      if (data === "单击播放当前动物声音") {
        player.play();
        obj.voiceImage = require("../../assets/images/播放中.gif");
        obj.voiceTitle = "单击暂停播放当前动物声音";
        $("#player").unbind("ended");
        $("#player").bind("ended", function() {
          obj.voiceImage = require("../../assets/images/开始播放.png");
          obj.voiceTitle = "单击播放当前动物声音";
        });
      } else if (data === "单击暂停播放当前动物声音") {
        player.pause();
        obj.voiceImage = require("../../assets/images/继续.png");
        obj.voiceTitle = "单击继续播放当前动物声音";
      } else if (data === "单击继续播放当前动物声音") {
        player.play();
        obj.voiceImage = require("../../assets/images/播放中.gif");
        obj.voiceTitle = "单击暂停播放当前动物声音";
      }
    },
    // 获取旅游资源数据
    getTouriseDetailsData() {
      this.toHeaderB.titleShow = false;
      this.axios
        .get(
          this.$store.state.Url10 +
            "wetlandResource/queryTouriseResourceByPage?soId=" +
            this.$store.state.Soid +
            "&Q_title_S_LK=" +
            this.search || sessionStorage.search
        )
        .then(data => {
          this.TouriseData = data.data.data;
          this.showData();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取动植物列表
    getListData() {
      this.toHeaderB.titleShow = false;
      if (this.type === 2) {
        this.axios
          .get(
            this.$store.state.Url10 +
              "wetland/impression/findAllIdAndName?type=0&soId=" +
              this.$store.state.Soid +
              "&name=" +
              this.search || sessionStorage.search
          )
          .then(data => {
            this.listData = data.data.data;
            this.showData();
          })
          .catch(err => {
            console.log(err);
          });
      } else if (this.type === 3) {
        this.axios
          .get(
            this.$store.state.Url10 +
              "wetland/impression/findAllIdAndName?type=1&soId=" +
              this.$store.state.Soid +
              "&name=" +
              this.search || sessionStorage.search
          )
          .then(data => {
            this.listData = data.data.data;
            this.showData();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 获取动植物信息
    getDetailsData() {
      this.axios
        .get(
          this.$store.state.Url10 +
            "wetland/impression/queryAnimalById?soId="+this.$store.state.Soid+"&wetlandAnimal.id=" +
            this.change.nowId || sessionStorage.id
        )
        .then(data => {
          data = data.data.data;
          if (this.type === 2) {
            let imgItem = [],
              voiceItem = [];
            for (let i in data.attList) {
              for (let x in this.imgList) {
                if (data.attList[i].uaType == this.imgList[x]) {
                  imgItem.push(data.attList[i]);
                  break;
                }
              }
              for (let z in this.voiceList) {
                if (data.attList[i].uaType == this.voiceList[z]) {
                  voiceItem.push(data.attList[i]);
                  break;
                }
              }
            }
            this.detailsSrc = this.$store.state.Url10 + imgItem[0].uaPath;
            if (voiceItem.length) {
              this.toHeaderB.haveVoice = true;
              this.toHeaderB.voiceImage = require("../../assets/images/开始播放.png");
              this.toHeaderB.voiceTitle = "单击播放当前动物声音";
              this.toHeaderB.voiceSrc =
                this.$store.state.Url10 + voiceItem[0].uaPath;
            } else {
              this.toHeaderB.haveVoice = false;
              this.toHeaderB.voiceImage = "";
              this.toHeaderB.voiceTitle = "";
              this.toHeaderB.voiceSrc = "";
            }
          } else {
            this.detailsSrc = this.$store.state.Url10 + data.attList[0].uaPath;
          }
          this.detailsTitle = data.name;
          this.content = data.content;
          this.setHeight();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 自动判断内容高度，不足则补
    setHeight() {
      setTimeout(function() {
        $(".details").css("height", "auto");
        let contentHeight =
          $(window).height() -
          $(".logo").height() -
          $(".footer").height() -
          20 -
          $(".post_pages").height() -
          30 -
          60;
        if ($(".details").height() < contentHeight) {
          $(".details").height(contentHeight);
        }
      }, 100);
    },
    // 渲染数据
    showData() {
      window.scrollTo(0, 0);
      this.toHeaderB.titleShow = false;
      if (this.type === 1) {
        for (let i in this.TouriseData) {
          if (
            this.TouriseData[i].id == this.change.nowId ||
            this.TouriseData[i].id == sessionStorage.id
          ) {
            this.change.nowIndex = i - 0;
            this.content = this.TouriseData[i].content;
            this.setHeight();
            if (this.change.nowIndex === 0 && this.TouriseData.length > 1) {
              this.change.noPrev = true;
              this.prevText = "上一条: 无";
              this.change.noNext = false;
              this.nextText =
                "下一条: " + this.TouriseData[this.change.nowIndex + 1].title;
            } else if (this.change.nowIndex === 0) {
              this.change.noPrev = true;
              this.prevText = "上一条: 无";
              this.change.noNext = true;
              this.nextText = "下一条: 无";
            } else if (this.change.nowIndex === this.TouriseData.length - 1) {
              this.change.noPrev = false;
              this.prevText =
                "上一条: " + this.TouriseData[this.change.nowIndex - 1].title;
              this.change.noNext = true;
              this.nextText = "下一条: 无";
            } else {
              this.change.noPrev = false;
              this.prevText =
                "上一条: " + this.TouriseData[this.change.nowIndex - 1].title;
              this.change.noNext = false;
              this.nextText =
                "下一条: " + this.TouriseData[this.change.nowIndex + 1].title;
            }
            break;
          }
        }
      } else if (this.type === 2 || this.type === 3) {
        for (let i in this.listData) {
          if (
            this.change.nowId === this.listData[i].id ||
            sessionStorage.id === this.listData[i].id
          ) {
            this.change.nowIndex = i - 0;
            this.getDetailsData();
            if (this.change.nowIndex === 0 && this.listData.length > 1) {
              this.change.noPrev = true;
              this.prevText = "上一条: 无";
              this.change.noNext = false;
              this.nextText =
                "下一条: " + this.listData[this.change.nowIndex + 1].name;
            } else if (this.change.nowIndex === 0) {
              this.change.noPrev = true;
              this.prevText = "上一条: 无";
              this.change.noNext = true;
              this.nextText = "下一条: 无";
            } else if (this.change.nowIndex === this.listData.length - 1) {
              this.change.noPrev = false;
              this.prevText =
                "上一条: " + this.listData[this.change.nowIndex - 1].name;
              this.change.noNext = true;
              this.nextText = "下一条: 无";
            } else {
              this.change.noPrev = false;
              this.prevText =
                "上一条: " + this.listData[this.change.nowIndex - 1].name;
              this.change.noNext = false;
              this.nextText =
                "下一条: " + this.listData[this.change.nowIndex + 1].name;
            }
            break;
          }
        }
      }
      this.toHeaderB.titleShow = true;
    },
    // 切换数据
    changeHander(type) {
      if (type === "prev") {
        if (this.change.nowIndex !== 0) {
          this.change.nowIndex--;
        } else {
          return;
        }
      } else if (type === "next") {
        if (this.type === 1) {
          if (this.change.nowIndex !== this.TouriseData.length - 1) {
            this.change.nowIndex++;
          } else {
            return;
          }
        } else if (this.type === 2 || this.type === 3) {
          if (this.change.nowIndex !== this.listData.length - 1) {
            this.change.nowIndex++;
          } else {
            return;
          }
        }
      }
      window.scrollTo(0, 0);
      this.toHeaderB.titleShow = false;
      if (this.type === 1) {
        this.content = this.TouriseData[this.change.nowIndex].content;
        this.setHeight();
        sessionStorage.id = this.TouriseData[this.change.nowIndex].id;
        if (this.TouriseData[this.change.nowIndex - 1]) {
          this.change.noPrev = false;
          this.prevText =
            "上一条: " + this.TouriseData[this.change.nowIndex - 1].title;
        } else {
          this.change.noPrev = true;
          this.prevText = "上一条: 无";
        }
        if (this.TouriseData[this.change.nowIndex + 1]) {
          this.change.noNext = false;
          this.nextText =
            "下一条: " + this.TouriseData[this.change.nowIndex + 1].title;
        } else {
          this.change.noNext = true;
          this.nextText = "下一条: 无";
        }
      } else if (this.type === 2 || this.type === 3) {
        this.change.nowId = this.listData[this.change.nowIndex].id;
        sessionStorage.id = this.change.nowId;
        this.getDetailsData();
        if (this.listData[this.change.nowIndex - 1]) {
          this.change.noPrev = false;
          this.prevText =
            "上一条: " + this.listData[this.change.nowIndex - 1].name;
        } else {
          this.change.noPrev = true;
          this.prevText = "上一条: 无";
        }
        if (this.listData[this.change.nowIndex + 1]) {
          this.change.noNext = false;
          this.nextText =
            "下一条: " + this.listData[this.change.nowIndex + 1].name;
        } else {
          this.change.noNext = true;
          this.nextText = "下一条: 无";
        }
      }
      this.toHeaderB.titleShow = true;
    }
  },
  mounted() {
    this.type = this.$route.query.type || sessionStorage.type - 0;
    this.change.nowId = this.$route.query.id || sessionStorage.id;
    this.search = this.$route.query.search || sessionStorage.search;
    if (this.type === 1) {
      this.toHeaderB.title = "旅游资源";
      this.toHeaderB.child = "旅游资源";
      this.toHeaderB.longTop = "Tourist";
      this.toHeaderB.childLink = "/stepInWetland/resource/1";
      // this.toHeaderB.logoSrc.backgroundImage =
      //   "url(" + require("../../assets/images/banner/旅游资源banner.png") + ")";
      this.getTouriseDetailsData();
    } else if (this.type === 2) {
      this.toHeaderB.title = "动物资源";
      this.toHeaderB.child = "动物资源";
      this.toHeaderB.longTop = "Animal";
      this.toHeaderB.childLink = "/stepInWetland/resource/2";
      // this.toHeaderB.logoSrc.backgroundImage =
      //   "url(" + require("../../assets/images/banner/动物资源banner.png") + ")";
      this.getListData();
    } else if (this.type === 3) {
      this.toHeaderB.title = "植物资源";
      this.toHeaderB.child = "植物资源";
      this.toHeaderB.longTop = "Plant";
      this.toHeaderB.childLink = "/stepInWetland/resource/3";
      // this.toHeaderB.logoSrc.backgroundImage =
      //   "url(" + require("../../assets/images/banner/植物资源banner.png") + ")";
      this.getListData();
    }
    setTimeout(function() {
      $(".header_nav li")
        .eq(1)
        .find("span")
        .find("a")
        .attr("class", "header_native");
    }, 0);
  }
};
</script>

<style scoped="scoped">
.container {
  background: white;
}
.details {
  overflow: hidden;
  padding: 20px 7%;
  text-align: left;
}
.details_title {
  text-align: center;
  padding: 10px 0 20px 0;
}
.details_img {
  text-align: center;
}
.details_img img {
  max-width: 500px;
  max-height: 300px;
}
.post_pages {
  padding: 0 7%;
  margin-top: 30px;
  height: 80px;
  box-sizing: border-box;
}
.post_pages p {
  line-height: 40px;
  overflow: hidden;
}
.post_pages span {
  display: inline-block;
  padding: 0 20px;
  width: 20%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  color: #15b559;
  border: 1px solid #15b559;
  transition: 0.2s linear;
  cursor: pointer;
}
.post_pages span:hover {
  background: #08961e;
  color: white;
}
.post_pages .special {
  cursor: not-allowed;
}
.post_pages .special:hover {
  background: transparent;
  color: #15b559;
}
.prev {
  float: left;
}
.next {
  float: right;
}
</style>

<style>
.details_content img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/stepInWetland/resource_post.vue